import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';
import { actionChannel } from 'redux-saga/effects';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_CONTACT_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- getContacts --------*/
    requestGetContacts: ['userId'],
    getContactsSuccess: ['getContactsResponse'],
    getContactsFailure: ['getContactsError'],

    /*---------- updateContactBatch --------*/
    requestUpdateContactBatch: ['contactBatchData'],
    updateContactBatchSuccess: ['updateContactBatchResponse'],
    updateContactBatchFailure: ['updateContactBatchError'],

    /*---------- getContactDetail --------*/

    requestGetContactDetail: ['contactId'],
    getContactDetailSuccess: ['getContactDetailResponse'],
    getContactDetailFailure: ['getContactDetailError'],


    /*---------- updateContactDetail --------*/

    requestUpdateContactDetail: ['contact'],
    updateContactDetailSuccess: ['updateContactDetailResponse'],
    updateContactDetailFailure: ['updateContactDetailError'],

    /*---------- removeContactDetail --------*/

    requestRemoveContactDetail: ['contactId'],
    removeContactDetailSuccess: ['removeContactDetailResponse'],
    removeContactDetailFailure: ['removeContactDetailError'],

    /*---------- generateContactReport --------*/
    requestGenerateContactReport: ['contactIds', 'userId'],
    generateContactReportSuccess: ['generateContactReportResponse'],
    generateContactReportFailure: ['generateContactReportError'],

    /*---------- getContactProperties --------*/
    requestGetContactProperties: ['contactId'],
    getContactPropertiesSuccess: ['getContactPropertiesResponse'],
    getContactPropertiesFailure: ['getContactPropertiesError'],

    /*---------- getContactRelatedProperties --------*/
    
    requestGetContactRelatedProperties:['contactId'],
    getContactRelatedPropertiesSuccess:['getContactRelatedPropertiesResponse'],
    getContactRelatedPropertiesFailure:['getContactRelatedPropertiesError'],

    /*---------- deleteContacts --------*/
    
    requestDeleteContacts:['contactIds'],
    deleteContactsSuccess:['deleteContactsResponse'],
    deleteContactsFailure:['deleteContactsError'],

};


const { Types, Creators } = createActions(functionDefinitions);

export const SagaContactTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaContactInitState = {
    deedDetail: [],
};

export const INITIAL_STATE = Immutable(SagaContactInitState);

/* ------------- Reducers ------------- */

/*---------- getContacts --------*/
export const requestGetContacts = (state, action) => {
    return state.merge(
        {
            getContactsFetching: true,
            userId: action.userId,
            getContactsResponse: null,
            getContactsError: null,
        });
};
export const getContactsSuccess = (state, action) => {
    return state.merge(
        {
            getContactsFetching: false,
            getContactsResponse: action.getContactsResponse,
        });
};
export const getContactsFailure = (state, action) => {
    return state.merge(
        {
            getContactsFetching: false,
            getContactsError: action.getContactsError,
        });
};

/*---------- updateContactBatch --------*/
export const requestUpdateContactBatch = (state, action) => {
    return state.merge(
        {
            updateContactBatchFetching: true,
            contactBatchData: action.contactBatchData,
            updateContactBatchResponse: null,
            updateContactBatchError: null,
        });
};
export const updateContactBatchSuccess = (state, action) => {
    return state.merge(
        {
            updateContactBatchFetching: false,
            updateContactBatchResponse: action.updateContactBatchResponse,
            getContactsResponse: action.updateContactBatchResponse
        });
};
export const updateContactBatchFailure = (state, action) => {
    return state.merge(
        {
            updateContactBatchFetching: false,
            updateContactBatchError: action.updateContactBatchError,
            updateContactBatchResponse: null,
        });
};


/*------- getContactDetail --------*/


export const requestGetContactDetail = (state, action) => {
    return state.merge(
        {
            getContactDetailFetching: true,
            contactId: action.contactId,
            getContactDetailResponse: null,
            getContactDetailError: null,
            updateContactDetailError: null,
            removeContactDetailError: null,
        });
};
export const getContactDetailSuccess = (state, action) => {
    return state.merge(
        {
            getContactDetailFetching: false,
            getContactDetailResponse: action.getContactDetailResponse,
            getContactDetailError: null

        });
};
export const getContactDetailFailure = (state, action) => {
    return state.merge(
        {
            getContactDetailFetching: false,
            getContactDetailError: action.getContactDetailError,

        });
};



/*---------- updateContactDetail --------*/


export const requestUpdateContactDetail = (state, action) => {
    return state.merge(
        {
            updateContactDetailFetching: true,
            contact: action.contact,
            updateContactDetailError: null,
            updateContactDetailResponse: null,
        });
};
export const updateContactDetailSuccess = (state, action) => {
    return state.merge(
        {
            updateContactDetailFetching: false,
            updateContactDetailResponse: action.updateContactDetailResponse,
            //  getContactDetailResponse:action.updateContactDetailResponse,
            updateContactDetailError: null

        });
};
export const updateContactDetailFailure = (state, action) => {
    return state.merge(
        {
            updateContactDetailFetching: false,
            updateContactDetailError: action.updateContactDetailError,

        });
};

/*---------- removeContactDetail --------*/


export const requestRemoveContactDetail = (state, action) => {
    return state.merge(
        {
            removeContactDetailFetching: true,
            contactId: action.contactId,
            removeContactDetailError: null,
            removeContactDetailResponse: null,
        });
};
export const removeContactDetailSuccess = (state, action) => {
    return state.merge(
        {
            removeContactDetailFetching: false,
            removeContactDetailResponse: action.removeContactDetailResponse,
            removeContactDetailError: null

        });
};
export const removeContactDetailFailure = (state, action) => {
    return state.merge(
        {
            removeContactDetailFetching: false,
            removeContactDetailError: action.removeContactDetailError,

        });
};

/*---------- generateContactReport --------*/
export const requestGenerateContactReport = (state, action) => {
    return state.merge(
        {
            generateContactReportFetching: true,
            contactIds: action.contactIds,
            userId: action.userId,
            generateContactReportResponse: null,
            generateContactReportError: null,
        });
};
export const generateContactReportSuccess = (state, action) => {
    return state.merge(
        {
            generateContactReportFetching: false,
            generateContactReportResponse: action.generateContactReportResponse,
        });
};
export const generateContactReportFailure = (state, action) => {
    return state.merge(
        {
            generateContactReportFetching: false,
            generateContactReportError: action.generateContactReportError,
        });
};


/*---------- getContactProperties --------*/
export const requestGetContactProperties = (state, action) => {
    return state.merge(
        {
            getContactPropertiesFetching: true,
            contactId: action.contactId
        });
};
export const getContactPropertiesSuccess = (state, action) => {
    return state.merge(
        {
            getContactPropertiesFetching: false,
            getContactPropertiesResponse: action.getContactPropertiesResponse,
            getContactPropertiesError: null
        });
};
export const getContactPropertiesFailure = (state, action) => {
    return state.merge(
        {
            getContactPropertiesFetching: false,
            getContactPropertiesError: action.getContactPropertiesError,

        });
};

/*---------- getContactRelatedProperties --------*/


export const requestGetContactRelatedProperties = (state,action) => {
  return state.merge(
    {
        getContactRelatedPropertiesFetching:true,
        contactId:action.contactId,
        getContactRelatedPropertiesResponse:null,
        getContactRelatedPropertiesError:null
    });
};
export const getContactRelatedPropertiesSuccess = (state,action) => {
  return state.merge(
    {
        getContactRelatedPropertiesFetching:false,
        getContactRelatedPropertiesResponse:action.getContactRelatedPropertiesResponse,
        
    });
};
export const getContactRelatedPropertiesFailure = (state,action) => {
  return state.merge(
    {
        getContactRelatedPropertiesFetching:false,
        getContactRelatedPropertiesError:action.getContactRelatedPropertiesError,
        
    });
};

/*---------- deleteContacts --------*/


export const requestDeleteContacts = (state,action) => {
  return state.merge(
    {
        deleteContactsFetching:true,
        contactIds:action.contactIds,
        deleteContactsResponse:null,
        deleteContactsError:null
    });
};
export const deleteContactsSuccess = (state,action) => {
  return state.merge(
    {
        deleteContactsFetching:false,
        deleteContactsResponse:action.deleteContactsResponse,
        getContactsResponse: action.deleteContactsResponse
        
    });
};
export const deleteContactsFailure = (state,action) => {
  return state.merge(
    {
        deleteContactsFetching:false,
        deleteContactsError:action.deleteContactsError,
        
    });
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- getContacts --------*/
    [Types.REQUEST_GET_CONTACTS]: requestGetContacts,
    [Types.GET_CONTACTS_SUCCESS]: getContactsSuccess,
    [Types.GET_CONTACTS_FAILURE]: getContactsFailure,

    /*---------- updateContactBatch --------*/
    [Types.REQUEST_UPDATE_CONTACT_BATCH]: requestUpdateContactBatch,
    [Types.UPDATE_CONTACT_BATCH_SUCCESS]: updateContactBatchSuccess,
    [Types.UPDATE_CONTACT_BATCH_FAILURE]: updateContactBatchFailure,


    /*---------- getContactDetail --------*/

    [Types.REQUEST_GET_CONTACT_DETAIL]: requestGetContactDetail,
    [Types.GET_CONTACT_DETAIL_SUCCESS]: getContactDetailSuccess,
    [Types.GET_CONTACT_DETAIL_FAILURE]: getContactDetailFailure,

    /*---------- updateContactDetail --------*/

    [Types.REQUEST_UPDATE_CONTACT_DETAIL]: requestUpdateContactDetail,
    [Types.UPDATE_CONTACT_DETAIL_SUCCESS]: updateContactDetailSuccess,
    [Types.UPDATE_CONTACT_DETAIL_FAILURE]: updateContactDetailFailure,

    /*---------- removeContactDetail --------*/

    [Types.REQUEST_REMOVE_CONTACT_DETAIL]: requestRemoveContactDetail,
    [Types.REMOVE_CONTACT_DETAIL_SUCCESS]: removeContactDetailSuccess,
    [Types.REMOVE_CONTACT_DETAIL_FAILURE]: removeContactDetailFailure,

    /*---------- generateContactReport --------*/
    [Types.REQUEST_GENERATE_CONTACT_REPORT]: requestGenerateContactReport,
    [Types.GENERATE_CONTACT_REPORT_SUCCESS]: generateContactReportSuccess,
    [Types.GENERATE_CONTACT_REPORT_FAILURE]: generateContactReportFailure,


    /*---------- getContactProperties --------*/
    [Types.REQUEST_GET_CONTACT_PROPERTIES]: requestGetContactProperties,
    [Types.GET_CONTACT_PROPERTIES_SUCCESS]: getContactPropertiesSuccess,
    [Types.GET_CONTACT_PROPERTIES_FAILURE]: getContactPropertiesFailure,

    /*---------- getContactRelatedProperties --------*/
    
    [Types.REQUEST_GET_CONTACT_RELATED_PROPERTIES]: requestGetContactRelatedProperties,
    [Types.GET_CONTACT_RELATED_PROPERTIES_SUCCESS]: getContactRelatedPropertiesSuccess,
    [Types.GET_CONTACT_RELATED_PROPERTIES_FAILURE]: getContactRelatedPropertiesFailure,

    /*---------- deleteContacts --------*/
    
    [Types.REQUEST_DELETE_CONTACTS]: requestDeleteContacts,
    [Types.DELETE_CONTACTS_SUCCESS]: deleteContactsSuccess,
    [Types.DELETE_CONTACTS_FAILURE]: deleteContactsFailure,
});


// WEBPACK FOOTER //
// ./src/redux/sagaContact/sagaContactRedux.ts